import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface BulkChargeHistoryItem {
  date: string;
  totalAmount: string;
  studentsCount: number;
  chargeName: string;
  bulkPaymentId: string;
}

interface GetBulkChargeHistoryParams {
  startDate: string;
  endDate: string;
}

export const getBulkChargeHistory = async (
  params: GetBulkChargeHistoryParams,
) => {
  const response = await baseAPI.get<Array<BulkChargeHistoryItem>>(
    'subscription-invoices/bulk-charge-history',
    {
      params: {
        ...params,
      },
    },
  );
  return response.data;
};

export const useGetBulkChargeHistory = (params: GetBulkChargeHistoryParams) => {
  return useQuery({
    queryKey: [KEYS.BULK_CHARGE_HISTORY, params.startDate, params.endDate],
    queryFn: () => getBulkChargeHistory(params),
    enabled: Boolean(params.startDate && params.endDate),
    // Keep prior rows while the date range refetch is in flight so EnrollioTable
    // does not see a fresh `[]` every render and infinite-loop (ENR-3465).
    placeholderData: keepPreviousData,
  });
};
